(() => {
  const coverageProducts = new Set([15066761953643, 15228426322283]);
  const roots = new Map();
  const labels = new WeakMap();
  let price = null;
  let refreshId = 0;
  let scheduled = false;
  const money = (cart) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency', currency: cart.currency || 'USD'
  }).format((cart.total_price - cart.items.reduce((sum, item) =>
    sum + (coverageProducts.has(Number(item.product_id)) ? item.final_line_price : 0), 0)) / 100);

  function render(root) {
    if (!root.querySelector('[data-target="non-coverage-button"]')) return;
    if (!root.querySelector('[data-mcr-redo-style]')) {
      const style = document.createElement('style');
      style.dataset.mcrRedoStyle = '';
      style.textContent = '[data-target="coverage-button"], [data-target="coverage-button"] *, [data-target="non-coverage-button"], [data-target="non-coverage-button"] * { font-weight: 700 !important; }';
      root.append(style);
    }
    root.querySelectorAll('[data-target="non-coverage-button"]').forEach((button) => {
      if (!labels.has(button)) labels.set(button, button.getAttribute('aria-label') || button.textContent.trim());
      let suffix = button.querySelector('[data-mcr-standard-total]');
      if (price === null) {
        suffix?.remove();
        if (button.getAttribute('aria-label') !== labels.get(button)) button.setAttribute('aria-label', labels.get(button));
        return;
      }
      if (!suffix) {
        suffix = document.createElement('span');
        suffix.dataset.mcrStandardTotal = '';
        (button.firstElementChild || button).append(suffix);
      }
      const text = ` | ${price}`;
      if (suffix.textContent !== text) suffix.textContent = text;
      const accessibleLabel = `${labels.get(button)}${text}`;
      if (button.getAttribute('aria-label') !== accessibleLabel) button.setAttribute('aria-label', accessibleLabel);
    });
  }
  function scan() {
    scheduled = false;
    document.querySelectorAll('redo-shopify-toggle').forEach((host) => {
      // Redo exposes its rendered DOM through this getter despite using a closed shadow root.
      const root = host.root || host.shadowRoot;
      host.dataset.mcrRootAvailable = String(Boolean(root?.querySelector));
      if (!root?.querySelector) return;
      if (!roots.has(root)) {
        const observer = new MutationObserver(schedule);
        observer.observe(root, {childList: true, subtree: true});
        roots.set(root, observer);
      }
      render(root);
    });
    for (const [root, observer] of roots) {
      if (root.host && !root.host.isConnected) { observer.disconnect(); roots.delete(root); }
    }
  }
  function schedule() {
    if (!scheduled) { scheduled = true; requestAnimationFrame(scan); }
  }
  async function refresh(cart) {
    const id = ++refreshId;
    price = null;
    schedule();
    try {
      if (!cart?.items || typeof cart.total_price !== 'number') {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {headers: {Accept: 'application/json'}, cache: 'no-store'});
        if (!response.ok) throw new Error('Cart unavailable');
        cart = await response.json();
      }
      if (id !== refreshId) return;
      price = money(cart);
      schedule();
    } catch { /* Keep Redo's original label when the amount cannot be verified. */ }
  }
  document.addEventListener('cart:change', (event) => refresh(event.detail?.cart));
  document.addEventListener('cart:refresh', () => refresh());
  document.addEventListener('redo:checkout-buttons-rendered', () => refresh());
  new MutationObserver(schedule).observe(document.body, {childList: true, subtree: true});
  customElements.whenDefined('redo-shopify-toggle').then(schedule);
  refresh();
})();

